import React, { Component } from 'react';
import { connect } from 'react-redux';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import { Switch, Route } from 'react-router-dom';
import shared from '../../../utils/shared.js';
import _ from 'lodash';
import AttractLoopTampa from './AttractLoopTampa';
import NavTampa from './NavTampa';
import DonorListsTampa from './DonorListsTampa';
import StoriesTampa from './StoriesTampa';
import MenuButtonTampa from './MenuButtonTampa';
import TimelineTampa from './TimelineTampa';
import UserInputTampa from './UserInputTampa';
const recent_interaction_timeout = 5000;
class TampaContainer extends Component {

  constructor(props) {
    super(props);
    this._screensNumber = this.getScreensNumber();
    this._attractLoopTree = []
    this.lastInteraction = new Date();
    this.idleRef = 0;

    this.state = {
      attractLoopRef: null,
      showNavButton: false,
      menuUrl: '/tampa/nav',
    }
  }

  componentDidMount() {
    try {
      document.addEventListener("keydown", this.handleKeyDown);
      //Setting Up Attract Loop    
      if (this.props.content.idle_delay) {
        this._idleDelay = this.props.content.idle_delay * 1000;
      } else {
        this._idleDelay = 120000;
      }

      // Get Display Root Folder
      let rootFolder = _.get(this.props.content, 'settings.selected_root_folder', null);
      if (rootFolder !== null && rootFolder !== undefined) {
        rootFolder = Number(rootFolder);
      }
  
      // Idle interaction Attract Loop.
      if (this.props.idleActive) {
        if (this.props.content.idle_delay > 0) {
          if (!this.props.content.settings.disallowInteraction) {
            window.addEventListener('mousedown', this.pageClick, false);
          }
          // Check if folder Attract Loop or Legacy
          let folderAttractLoop = _.get(this.props.content.settings, 'folderAttractLoop', false);
          if (folderAttractLoop) {
            let topAttractLoop = _.filter(this.props.content.story_categories, { parent_category: rootFolder, contents: { custom_fields: { folder_type: { val: { value: "attract_loop" } } } } });
            if (topAttractLoop && topAttractLoop[0]) {
              this._attractLoopTree = shared.createFolderTree(this.props.content.story_categories, this.props.content.folder_modules, null, this.props.content.stories, this.props.content.dm_active, topAttractLoop[0].name, 'sorting_name');
  
              // this.props.setOptions({
              //   attractLoopTree: this._attractLoopTree
              // });
  
              // this.folderCheckRecentInteraction();
              // this.checkIdleTimeout();
              this.folderGoIdle("idle");
            }
          }
        }
      }
    } catch(e) {
      console.log(e);
    }
  }

  toggleShowNav = (toggleOn) => {
    this.setState({
      showNavButton: toggleOn
    })
  }

  showNavButton = (show) => {
    this.setState({
      showNavButton: show
    });
  }

  openNav = () => {
    this.props.history.replace(this.state.menuUrl);
  }

  getScreensNumber = () => {
    try {
      return this.props.content.settings.display_blocks[0].screens.length
    } catch (e) {
      return 1;
    }
  }

  folderGoIdle = (type) => {
    if (type === "recentInteraction") {
      this.setState({
        recentInteraction: false
      })
    }
    else {
      this.setState({
        idle: true
      });

      this.folderCycleIdle();
      this.folderCycleIdleLoop();
    }
  }
  
  folderNavroute = (ref, type, source, options) => {
    if (ref === null) {
      if (this.props.active_module !== undefined) {
        ref = this.props.active_module //maintain module if not changed
      }
    }
    if (type === null) {
      type = this.getActiveModuleType();
    }

    let module;
    module = this._attractLoopTree.children[ref];

    this.setState({
      displayNav: false,
      options: options,
      showNav: true,
      attractLoopModule: module,
      attractLoopRef: ref
    });
    this.props.history.replace("/tampa");
  }

  folderCycleIdle = () => {
    if (this.idleRef >= this._attractLoopTree.children.length) {
      this.idleRef = 0
    }
    let type = _.get(this._attractLoopTree.children[this.idleRef].contents, 'custom_fields.story_type.val.value', 'story');
    this.folderNavroute(this.idleRef, type, "idle", { idleModule: this.idleRef });
  }

  folderCycleIdleLoop = () => {
    clearTimeout(this._idleLoopTimeout);
    let timeout = Number(_.get(this._attractLoopTree.children[this.idleRef].contents, 'custom_fields.cycle_timeout.val', 30));
    this._idleLoopTimeout = setTimeout(() => {
      this.folderCycleIdle();
      this.folderCycleIdleLoop();
    }, timeout * 1000);
    this.idleRef++;
  }

  folderCheckRecentInteraction = () => {
    let msPassed = (new Date()).getTime() - this.lastInteraction.getTime();
    if (msPassed > recent_interaction_timeout) {
      this.folderGoIdle("recentInteraction");
    }
    else {
      clearTimeout(this._recentInteractionTimeout);
      this._recentInteractionTimeout = setTimeout(() => {
        this.folderCheckRecentInteraction();
      }, recent_interaction_timeout - msPassed); //avoids extra settings of timeout below interval check
    }
  }

  checkIdleTimeout = () => {
    let msPassed = (new Date()).getTime() - this.lastInteraction.getTime();
    if (msPassed > this._idleDelay) {
      this.folderGoIdle("idle");
    } else {
      clearTimeout(this._idleTimeout);
      this._idleTimeout = setTimeout(() => {
        this.checkIdleTimeout();
      }, this._idleDelay - msPassed); //avoids extra settings of timeout below interval check
    }
  }
  
  resume = () => {
    this.idleRef = 0;
    this.lastInteraction = new Date();
    this.checkIdleTimeout();

    if (this.state.idle === true) {
      this.props.history.replace('/tampa/nav');
      this.setState({
        idle: false,
        attractLoopRef: this.idleRef
      })
      clearTimeout(this._idleLoopTimeout);
    }
    if (this.state.recentInteraction === false) {
      this.setState({
        recentInteraction: true
      })
    }
  }

  pageClick = () => {
    this.resume();
  }

  navRoute = (route, module) => {
    if (module) {
      this.setState({
        module: module
      });
    }
    this.props.history.replace(route);
  }

  render() {
    const { location } = this.props;
    const key = this.props.location.pathname + this.props.location.search;
    return (
      <div className={this.props.content.font_class} style={{ color: this.props.content.settings.main_font_color }}>
        <CSSTransitionGroup
          component='div'
          className="containerFade"
          style={{ minHeight: '100%' }}
          transitionName='fastfadedelay'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          <Switch key={key} location={location}>
            <Route path='/tampa/nav' render={props => <NavTampa {...props} toggleShowNav={this.toggleShowNav} navRoute={this.navRoute} content={this.props.content} screen={this.props.screen} screensNumber={this._screensNumber} />} />
            <Route path='/tampa/stories' render={props => <StoriesTampa {...props} module={this.state.module} navRoute={this.navRoute} screen={this.props.screen} content={this.props.content} screensNumber={this._screensNumber} showNavButton={this.showNavButton}/>} />
            <Route path='/tampa/donor_lists' render={props => <DonorListsTampa {...props} module={this.state.module} content={this.props.content} navRoute={this.navRoute} screen={this.props.screen} screensNumber={this._screensNumber}/>} />
            <Route path='/tampa/timeline' render={props => <TimelineTampa {...props} content={this.props.content} module={this.state.module} navRoute={this.navRoute} screen={this.props.screen} screensNumber={this._screensNumber}/>} />
            <Route path='/tampa/search' render={props => <UserInputTampa {...props} navRoute={this.navRoute} content={this.props.content} module={this.state.module} screen={this.props.screen} screensNumber={this._screensNumber} showNavButton={this.showNavButton} />} />
          </Switch>

          {/* Attract Loop */}
          {
            this.state.idle ?
              <AttractLoopTampa key={this.state.attractLoopRef} tree={this._attractLoopTree} attractLoopRef={this.state.attractLoopRef} />
              : null
          }
        </CSSTransitionGroup >

        <CSSTransitionGroup
          component='div'
          className="containerFade"
          style={{ minHeight: '100%' }}
          transitionName='fastfadedelay'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          <div key={this.state.showNavButton}>
            {this.state.showNavButton && !this.state.idle ?
              <MenuButtonTampa
                unit={this.props.screen.r9_16.p10 / this.props.screensNumber}
                width="3.90625vh"
                height="5.625vh"
                top="50vh"
                border="0.84375vh"
                clickAction={this.openNav}
                text={'menu'}
              >
              </MenuButtonTampa>
              : null}
          </div>
        </CSSTransitionGroup >

      </div >
    )
  }
}

const mapStateToProps = (state) => {
  let idleActive = true;
  let idle = shared.parseStringParam(window.location.href, "idle");
  if (state.content.idle_delay === 0 || idle === "false") {
    idleActive = false;
  }
  return {
    content: state.content,
    screen: state.screen,
    idleActive: idleActive,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TampaContainer);


// WEBPACK FOOTER //
// ./src/Components/Theme/Tampa/TampaContainer.jsx